// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktopWrap":"bgt_a","AdSlotBranding__desktop":"bgt_b","AdSlotBranding__mobile":"bgt_c"};